import { render } from "./InitiativeCermi.vue?vue&type=template&id=181516f6&scoped=true"
import script from "./InitiativeCermi.vue?vue&type=script&lang=js"
export * from "./InitiativeCermi.vue?vue&type=script&lang=js"

import "./InitiativeCermi.vue?vue&type=style&index=0&id=181516f6&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181516f6"]])

export default __exports__